// noinspection JSUnusedGlobalSymbols

import { config } from '@/config';
import { resetAuthStore } from '@/stores/auth.store.ts';
import axios from 'axios';
import { navigationHelper } from '@/router/navigationHelper.ts';

export const api = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true,
  headers: {
    'Content-type': 'application/json',
  },
});

// api.interceptors.request.use(function (config) {
//   const auth = useAuthStore.getState();
//   const token = auth.token;
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// }, function (error) {
//   return Promise.reject(error);
// });

export function getSearchRedirect() {
  return window.location.pathname + window.location.search + window.location.hash;
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      if (!window.location.pathname.includes('login')) {
        resetAuthStore();
        if (navigationHelper.navigate) {
          await navigationHelper.navigate({ to: '/login/$', search: { redirect: getSearchRedirect() } });
        }
      }
    }
    return Promise.reject(error);
  },
);

export interface ApiResponse {
  success?: string;
  error?: string;
}

export interface IPaginatedResponse<T> {
  items: T[];
  pagination: {
    per_page: number;
    start: number;
    total: number;
  };
}

export interface ApiStatusResponse extends ApiResponse {
  status: 'success' | 'error' | 'warning';
  message: string;
}

export async function apiGet<T = ApiResponse>(url: string, params?: any): Promise<T> {
  return await api.get<T>(url, { params }).then((res) => res?.data);
}

export async function apiPost<T extends ApiStatusResponse>(url: string, data?: any): Promise<T> {
  return await api.post<T>(url, data).then((res) => res?.data);
}

export async function apiPostGet<T = ApiResponse>(url: string, data?: any): Promise<T> {
  return await api.post<T>(url, data).then((res) => res?.data);
}

export async function apiDelete<T extends ApiStatusResponse>(url: string): Promise<T> {
  return await api.delete<T>(url).then((res) => res?.data);
}

export async function apiDeleteGet<T extends ApiResponse>(url: string): Promise<T> {
  return await api.delete<T>(url).then((res) => res?.data);
}

export async function apiPostFormData<T>(url: string, data: FormData): Promise<T> {
  return await api
    .post<T>(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => res?.data);
}

export async function apiPostFormDataGet<T>(url: string, data: FormData): Promise<T> {
  return await apiPostFormData(url, data).then((res) => res as T);
}

export async function apiGetFile(url: string, type = 'application/pdf'): Promise<Blob> {
  return await api
    .get(url, {
      responseType: 'blob',
    })
    .then((res) => {
      return new Blob([res.data], { type });
      // const blob = new Blob([res.data], {type: res.headers["content-type"]});
      // const fileName = res.headers["content-disposition"].split("filename=")[1].replace(/"/g, "");
      // const file = new File([blob], fileName);
      // return file;
    });
}

// @ts-ignore
// noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
export function delay<T>(res: T, timeout = 1000): Promise<T> {
  return new Promise((resolve) => {
    return setTimeout(() => resolve(res), timeout);
  });
}
